<template>
  <Popover ref="popover" @show="onPopoverShow" @hide="onPopoverHide">
    <el-input-number
      v-model="innerValue"
      controls-position="right"
      :step="1"
      :min="0"
      :max="max"
      style="width: 110px"
      @keyup.enter.native="confirm"
    />

    <div style="display: inline-block">
      <el-button type="text" @click="confirm">保存</el-button>
    </div>

    <el-button slot="ref" type="text">
      {{ value }}
    </el-button>
  </Popover>
</template>

<script>
import Popover from '@/components/popover/index.vue'
import { truncatedNumber } from '@/common/js/utils.js'

export default {
  props: {
    value: [Number, String],
    precision: {
      type: Number,
      default: 2
    },
    max: {
      type: Number,
      default: 99999999
    }
  },
  components: { Popover },
  data() {
    return {
      innerValue: ''
    }
  },
  methods: {
    confirm() {
      this.$emit('input', truncatedNumber(parseFloat(this.innerValue), this.precision))
      this.$refs.popover.close()
    },
    onPopoverShow() {
      if (this.value > 0) {
        this.innerValue = this.value
      }
    },
    onPopoverHide() {
      this.innerValue = ''
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
